<script lang="ts">
	import DecoratedHeadline from "../components/DecoratedHeadline.svelte";
	import Layout from "../components/Layout.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./CareerDetail.translations.json";
	import type { CareerDetailProps } from "./CareerDetailProps.js";
	import Button from "../components/Button.svelte";
	import Modal from "../components/Modal.svelte";
	import CareerForm from "../components/Career/CareerForm.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import Content from "../components/Content.svelte";
	import Breadcrumbs from "../components/Breadcrumbs.svelte";
	import arrowRightLong from "../../../core/assets/icons/arrow-right-long.svg?raw";
	import CareerDesktopGallery from "../components/Career/CareerDesktopGallery.svelte";
	import CareerMobileGallery from "../components/Career/CareerMobileGallery.svelte";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { setContext } from "svelte";

	type $$Props = CareerDetailProps;

	const { position, breadcrumbs } = $$restProps as $$Props;
	const { STORAGE_URL } = getGlobalSettings();

	const translate = getTranslate(translations);

	let showCareerModal = false;

	function openCareerModal(): void {
		showCareerModal = true;
	}

	$: [primaryImage] = position.images;
	setContext(thumbnailImageContextKey, primaryImage ? `${STORAGE_URL}/${primaryImage.path}` : undefined);
</script>

<Modal bind:show={showCareerModal} class="!bg-gray lg:w-[46.25rem]">
	<CareerForm {position} on:close={() => (showCareerModal = false)} />
</Modal>

<Layout>
	<div class="container flex flex-col md:items-center">
		<Breadcrumbs {breadcrumbs} />
		<section>
			<div class="lg:w-[50rem]">
				<DecoratedHeadline class="!pl-0 !text-left">{nbspify(position.name)}</DecoratedHeadline>
				<h2 class="text-md font-normal lg:text-[1.5rem] lg:leading-8">{nbspify(position.perex)}</h2>
			</div>
			<div class="lg:w-[50rem]">
				<Content content={position.content} />
			</div>
			<Button on:click={openCareerModal} variant="primary" icon={arrowRightLong}>
				{translate("getInTouch")}
			</Button>
		</section>
		{#if position.images}
			<section class="hidden md:block lg:w-[57.5rem]">
				<CareerDesktopGallery {position} images={position.images} />
			</section>
			<section class="md:hidden">
				<CareerMobileGallery class="md:hidden" {position} images={position.images} />
			</section>
		{/if}
	</div>
</Layout>
